import React from 'react'
// images
import logo from '../../assets/images/logo.png'

const Logo = () => {
    return (
        <img src={logo} alt="logo" />
    )
}

export default Logo